<template>
  <a-button style="align-self: center" type="primary" @click="logOut">
    <logout-outlined />
    {{ t("login.action.logout") }}
  </a-button>
</template>
<script lang="ts">
import { ref, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import router from "../router";
import { LogoutOutlined } from "@ant-design/icons-vue";
import { useUserStore } from "../store/modules/user";
export default defineComponent({
  components: {
    LogoutOutlined,
  },
  setup() {
    const store = useUserStore();
    const { t } = useI18n();
    const logOut = () => {
      store.authLogout().then(() => {
        router.push("/");
      });
    };
    return {
      logOut,
      t,
      router,
    };
  },
});
</script>
